import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold mb-4" }, "Gruppe bearbeiten", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Gruppeninformationen")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-lg-12" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = { class: "col-lg-3 col-form-label" }
const _hoisted_12 = { class: "col-lg-9" }
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = { class: "col-lg-9" }
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = { class: "col-lg-3 col-form-label" }
const _hoisted_18 = { class: "col-lg-9" }
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = { class: "col-lg-3 col-form-label" }
const _hoisted_21 = { class: "col-lg-9" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "input-group-prepend" }
const _hoisted_24 = { class: "btn-group justify-content-center position-static" }
const _hoisted_25 = {
  href: "#",
  class: "btn bg-light dropdown-toggle border-radius-top-right-0 border-radius-bottom-right-0",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_26 = {
  class: "dropdown-menu",
  style: {}
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = { class: "col-lg-3 col-form-label" }
const _hoisted_30 = { class: "col-lg-9" }
const _hoisted_31 = { class: "input-group" }
const _hoisted_32 = { class: "input-group-prepend" }
const _hoisted_33 = { class: "btn-group justify-content-center position-static" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn bg-light dropdown-toggle border-radius-top-right-0 border-radius-bottom-right-0",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}, " Farbe ", -1)
const _hoisted_35 = {
  class: "dropdown-menu",
  style: {}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "input-group-append" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "card-footer text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.group.name.name), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group.name.value) = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.group.name.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-lg-3 col-form-label", {'text-danger':_ctx.group.alias.error}])
                  }, _toDisplayString(_ctx.group.alias.name), 3),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.group.alias.error}]),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.group.alias.value) = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.group.alias.value]
                    ]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.group.alias.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.group.description.name), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.group.description.value) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.group.description.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.group.icon.name), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("a", _hoisted_25, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.group.icon.value)
                            }, null, 2)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconList, (data, fIndex) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: fIndex,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.chooseIcon(data))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(data)
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(data), 1)
                              ], 8, _hoisted_27))
                            }), 128))
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.group.icon.value) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.group.icon.value]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.group.class.name), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: 'color_'+color.class,
                                class: "dropdown-item",
                                onClick: _withModifiers(($event: any) => (_ctx.chooseColor(color.class)), ["prevent"])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge mr-3", 'badge-'+color.class])
                                }, "TEXT text", 2),
                                _createElementVNode("span", _hoisted_37, _toDisplayString(color.name), 1)
                              ], 8, _hoisted_36))
                            }), 128))
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.group.class.value) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.group.class.value]
                      ]),
                      _createElementVNode("span", _hoisted_38, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["input-group-text", 'bg-'+_ctx.group.class.value])
                        }, _hoisted_40, 2)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveGroup && _ctx.saveGroup(...args)))
            }, "Gruppe speichern")
          ])
        ])
      ])
    ])
  ]))
}